import React, { FC } from 'react';
import * as Styled from './DiagnosticsStepsVideo.styles';
import getVideoId from 'get-video-id';

function getEmbedVideoUrl(url: string): string | null {
  const videoInfo = getVideoId(url);

  if (videoInfo.service === 'vimeo') return `https://player.vimeo.com/video/${videoInfo.id}`;
  return null;
}

interface DiagnosticsStepsVideoProps {
  url: string;
}

const DiagnosticsStepsVideo: FC<DiagnosticsStepsVideoProps> = ({ url }) => {
  const videoUrl = getEmbedVideoUrl(url);

  return videoUrl ? (
    <Styled.DiagnosticsStepsVideoContainer>
      <div>
        <iframe title={`video-${url}`} src={videoUrl} allowFullScreen loading="eager" />
      </div>
    </Styled.DiagnosticsStepsVideoContainer>
  ) : null;
};

export default DiagnosticsStepsVideo;
